import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EditSettingsModalPage } from './edit-settings-modal.page';

const routes: Routes = [
  {
    path: '',
    component: EditSettingsModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EditSettingsModalPageRoutingModule {}
